var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import TwoPicturesBlock from '../../../editor/TwoPicturesBlock/TwoPicturesBlock';
import { MultiImageWrapper, ImageDescription } from '../styles';
var MagazineMultiImage = function (_a) {
    var post = _a.post;
    return (React.createElement(MultiImageWrapper, null,
        React.createElement(TwoPicturesBlock, { post: __assign(__assign({}, post), { caption: '' }), isEditable: false }),
        React.createElement(ImageDescription, null, post.caption)));
};
export default MagazineMultiImage;
//# sourceMappingURL=MagazineMultiImage.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import TwoPicturesBlock from '../../../editor/TwoPicturesBlock/TwoPicturesBlock';
import { MultiImageWrapper, ImageDescription } from '../styles';
var MagazineMultiImage = function (_a) {
    var post = _a.post;
    return (React.createElement(MultiImageWrapper, null,
        React.createElement(TwoPicturesBlock, { post: __assign(__assign({}, post), { caption: '' }), isEditable: false }),
        React.createElement(ImageDescription, null, post.caption)));
};
export default MagazineMultiImage;
//# sourceMappingURL=MagazineMultiImage.js.map